import { SHA256, enc } from 'crypto-js';

export type CustomFormType = 'general' | 'donation' | 'donor update' | 'donor update - debit form';

type DonationStep = 'amount' | 'personal detail' | 'payment';

interface BaseFormProps {
    formName: string;
    formType: CustomFormType;
}

type OnFormLoadedProps = BaseFormProps;

interface OnFormErrorProps extends BaseFormProps {
    errorMessage?: string;
}

interface OnFormCompleteProps extends BaseFormProps {
    userId: string;
}

interface OnFormFieldCompleteProps extends BaseFormProps {
    fieldName: string;
    value?: string;
}

interface OnFormStepCompleteProps extends BaseFormProps {
    stepName: DonationStep;
}

export const DATALAYER_EVENT = {
    FORM_START: 'custom.form.start',
    FIELD_COMPLETE: 'custom.form.field.complete',
    FORM_COMPLETE: 'custom.form.complete',
    FORM_ERROR: 'custom.form.error',
    FORM_STEP_COMPLETE: 'custom.form.step.complete',
};

const isDataLayerExists = window.dataLayer;

export const sha256Encription = (text: string): string => {
    return SHA256(text).toString(enc.Hex);
};

export const pushDataLayerOnFormLoaded = ({ formName, formType }: OnFormLoadedProps): void => {
    if (!isDataLayerExists) {
        return;
    }

    const { dataLayer } = window;

    dataLayer.push({
        event: DATALAYER_EVENT.FORM_START,
        name: formName,
        type: formType,
    });
};

export const pushDataLayerOnFormError = ({ formName, formType, errorMessage = '' }: OnFormErrorProps): void => {
    if (!isDataLayerExists) {
        return;
    }

    const { dataLayer } = window;

    dataLayer.push({
        event: DATALAYER_EVENT.FORM_ERROR,
        name: formName,
        type: formType,
        txt_value: errorMessage,
    });
};

export const pushDataLayerOnFormComplete = ({ formName, formType, userId }: OnFormCompleteProps): void => {
    if (!isDataLayerExists) {
        return;
    }

    const { dataLayer } = window;

    dataLayer.push({
        event: DATALAYER_EVENT.FORM_COMPLETE,
        user_id: userId,
        name: formName,
        type: formType,
    });
};

export const pushDataLayerOnFormFieldComplete = ({ fieldName, formName, formType, value = '' }: OnFormFieldCompleteProps): void => {
    if (!isDataLayerExists) {
        return;
    }

    const { dataLayer } = window;

    dataLayer.push({
        event: DATALAYER_EVENT.FIELD_COMPLETE,
        name: formName,
        type: formType,
        field: fieldName,
        txt_value: value,
    });
};

export const pushDataLayerOnFormStepComplete = ({ formName, formType, stepName }: OnFormStepCompleteProps): void => {
    if (!isDataLayerExists) {
        return;
    }

    const { dataLayer } = window;

    dataLayer.push({
        event: DATALAYER_EVENT.FORM_STEP_COMPLETE,
        name: formName,
        type: formType,
        step: stepName,
    });
};


